var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.99 14.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.85,11.49c2.28-.05,4.14-1.94,4.14-4.23s-1.8-4.15-4.09-4.23l-18.26-.62v9.45l18.2-.37h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39,9.1l2.03.79c1.1,2.44,3.55,4.15,6.39,4.15h.27l56.4-2.11,1.39-.03V2.35l-1.37-.05L10.11,0h-.29c-2.8,0-5.21,1.65-6.34,4.03l-2.22,1.04C.45,5.45-.03,6.24,0,7.13c.03.89.57,1.65,1.4,1.97h-.01ZM1.94,6.52l.92-.43c-.04.3-.07.61-.07.92s.03.62.07.93l-.89-.35c-.32-.13-.37-.41-.37-.53s.02-.4.34-.55h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreroll);
export default __webpack_public_path__ + "static/media/preroll.aebf3da1aad9d78a60c960ddcf97dceb.svg";
export { ForwardRef as ReactComponent };